/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface PatchedAssessmentComment
 */
export interface PatchedAssessmentComment {
  /**
   *
   * @type {string}
   * @memberof PatchedAssessmentComment
   */
  comment?: string;
}

/**
 * Check if a given object implements the PatchedAssessmentComment interface.
 */
export function instanceOfPatchedAssessmentComment(value: object): value is PatchedAssessmentComment {
  return true;
}

export function PatchedAssessmentCommentFromJSON(json: any): PatchedAssessmentComment {
  return PatchedAssessmentCommentFromJSONTyped(json, false);
}

export function PatchedAssessmentCommentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PatchedAssessmentComment {
  if (json == null) {
    return json;
  }
  return {
    comment: json['comment'] == null ? undefined : json['comment'],
  };
}

export function PatchedAssessmentCommentToJSON(value?: PatchedAssessmentComment | null): any {
  if (value == null) {
    return value;
  }
  return {
    comment: value['comment'],
  };
}
